import { handleValidationChange } from "../CommonValidation";


export const validatePurchaseRequest = (data, items, setIsError) => {
    console.log(data)
    var isValid = true;

    if (data.department_id === "" || data.department_id === null || data.department_id === undefined) {
        handleValidationChange("department_id", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("department_id", false, setIsError);
    }

    if (data.branch_id === "" || data.branch_id === null || data.branch_id === undefined) {
        handleValidationChange("branch_id", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("branch_id", false, setIsError);
    }

    if (data.requested_by === "" || data.requested_by === null || data.requested_by === undefined) {
        handleValidationChange("requested_by", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("requested_by", false, setIsError);
    }

    if (data.request_date === "" || data.request_date === null || data.request_date === undefined) {
        handleValidationChange("request_date", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("request_date", false, setIsError);
    }

    if (data.required_date === "" || data.required_date === null || data.required_date === undefined) {
        handleValidationChange("required_date", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("required_date", false, setIsError);
    }

    if (items.length !== 0) {
        handleValidationChange("itemList", false, setIsError);
    } else {
        handleValidationChange("itemList", true, setIsError);
        isValid = false;
    }


    return isValid
  
}


export const validatePurchaseRequestItems = (items) => {
    console.log(items)
    const errors = {};
    // const finalItems = []
    items.map((item, itemIndex) => {

      if (!(item.quantity.toString())|| (parseInt(item.quantity) <= 0)) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          quantity: 'Qty is required and should be greater than 0',
        };
      }

      if (!(item.uom.toString())||item.uom==='') {
        errors[itemIndex] = {
          ...errors[itemIndex],
          uom: 'Unit is required',
        };
      }

      if (!(item.description.toString())||item.description==='') {
        errors[itemIndex] = {
          ...errors[itemIndex],
          description: 'Description is required',
        };
      }

      if (!(item.selling_price.toString())|| (parseInt(item.selling_price) <= 0)) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          selling_price: 'Price is required and should be greater than 0',
        };
      }
    });
    return errors;
}